export { default as InputBarIcon } from "./InputBarIcon";
